import { RouteType } from 'types/RouteType';
import { ServiceStoreType } from 'types/ServiceStoreTypes';
// import HolidayScheduleIcon from '@mui/icons-material/CalendarViewDay';

const holidayScheduleRoute: RouteType[] = [
  {
    name: 'Holiday Schedule',
    path: '/holiday-schedule',
    layout: '/app',
    viewportCard: {
      header: {
        title: 'Holiday Schedule',
        // If no specific header component is needed, a default one will be used
        // component: () => import('./HolidaySchedule.Header'),
        enableRefreshButton: true,
        enableBackButton: true,
      },
      body: {
        // component: () => import('./HolidaySchedule.Body'),
        // grayBackground:  No equivalent in the old format, set as needed
        gridContainer: {
          namespace: 'HolidayScheduleDataGrid',
          storeName: 'datesHolidaysStore',
          // customEntity: 'qrCodeRows',
          // fixedRowCount: 2,
          columnHeaders: [
            {
              width: 200,
              title: 'Name',
              key: 'name',
            },
            {
              width: 200,
              title: 'Date',
              key: 'date',
              dataType: 'date',
            },
            {
              width: 200,
              title: 'Type',
              key: 'type',
            },
          ],
          defaultSort: {
            sortBy: ['date'],
            sortDirection: { date: 'ASC' },
          },
          enableInlineEdit: true,
          enableHover: true,
          onSubmitEdits: (id, data, rootStore) => {
            console.log('onSubmitEdits', id, data, rootStore);
            const datesHolidaysStore =
              rootStore.datesHolidaysStore as ServiceStoreType;
            datesHolidaysStore.patch(Number(id), data as object);
          },
        },
      },
    },
    group: 'Accounting',
    requiresAuth: true,
    requiresPermission: false,
    requiresAdmin: true, // Custom property, retain it.
    channels: ['dates/holidays'],
    // beforeEnter: async ({ rootStore }) => {
    //   const {
    //     datesHolidaysStore: { find: findHolidays },
    //   } = rootStore;
    //   findHolidays();
    //   return true;
    // },
    // icon: HolidayScheduleIcon, // Remove icon, it's not used in the new format.
    //  // No direct equivalent, handle in sidebar config.
    //   // No direct equivalent, handle in home shortcut config.
    // hidden: false, // No direct equivalent, handle in routing logic (e.g., conditional rendering in sidebar)
  },
];

export default holidayScheduleRoute;
